<script>
export default {
  name: "BreadCrumbs",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <eg-b-row>
    <eg-b-col>
      <eg-b-breadcrumb :items="items"></eg-b-breadcrumb>
    </eg-b-col>
  </eg-b-row>
</template>
